// DI-3-R1-FE-analyst — the one sentence after "Send back to the pilot…".
//
// The send-back moves the set out of analysis (intake/v1 `reopen`: CREATED /
// verdict_ready, back in the pilot's intake), so the Analysis Tool leaves the
// set's page for the Data Acquisitions list — the exit the lock-contention
// dialog's Cancel already uses (`AnalysisFeature.tsx` LockMount). The burger
// menu that sent the set back unmounts with the page, so the sentence travels
// in the router's location state and is shown here, once: closing it clears
// the state (a reload does not show it again).
import { Alert, Snackbar } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

export const SENT_BACK_NOTICE_KEY = "sentBackNotice";

export interface SentBackNoticeState {
  [SENT_BACK_NOTICE_KEY]: string;
}

function readNotice(state: unknown): string | null {
  if (state === null || typeof state !== "object") return null;
  const v = (state as Record<string, unknown>)[SENT_BACK_NOTICE_KEY];
  return typeof v === "string" && v.length > 0 ? v : null;
}

export function SentBackNotice(): React.ReactElement | null {
  const location = useLocation();
  const navigate = useNavigate();
  const text = readNotice(location.state);
  if (text === null) return null;
  const close = (): void => {
    void navigate(`${location.pathname}${location.search}`, {
      replace: true,
      state: null,
    });
  };
  return (
    <Snackbar
      open
      autoHideDuration={6000}
      onClose={close}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        severity="success"
        variant="filled"
        onClose={close}
        data-testid="sent-back-notice"
      >
        {text}
      </Alert>
    </Snackbar>
  );
}
